// Where Messages lives, and how the open conversation is written into the address.
//
// Messages has no menu row: the round link in the top bar leads here, the way the
// search pop-up leads to /search. The open conversation travels in the query of this
// one fixed path (?c=<conversation id> for a one-to-one chat, ?g=<group id> for a
// group), so reload and Back work, and analytics names the page '/messages' and never
// sees which conversation it was (lib/clientAnalytics).
export const MESSAGES_PATH = '/messages';

/** Which conversation is open. A one-to-one chat and a group never share an id or a route. */
export type OpenConversation = { kind: 'direct' | 'group'; id: string };

/** The address that opens one conversation. */
export const conversationPath = (open: OpenConversation): string =>
  `${MESSAGES_PATH}?${new URLSearchParams({ [open.kind === 'group' ? 'g' : 'c']: open.id }).toString()}`;

/** The conversation an address names, or null. Anyone can type one, so the server decides whether it opens. */
export const openConversationFrom = (params: URLSearchParams): OpenConversation | null => {
  const chat = params.get('c')?.trim();
  if (chat) return { kind: 'direct', id: chat };
  const group = params.get('g')?.trim();
  return group ? { kind: 'group', id: group } : null;
};

// The page reads a conversation; the count on the top-bar link is the shell's. The page
// says so with this event instead of reaching into the shell (as components/shell/
// openSearch does for search), and the link asks the server for the count again.
export const MESSAGES_READ_EVENT = 'cp:messages-read';

export const tellMessagesRead = (): void => {
  window.dispatchEvent(new Event(MESSAGES_READ_EVENT));
};
